export const initAnimations = () => {
  const animatedBlocks = document.querySelectorAll('[data-animate]');
  if (!animatedBlocks.length) {
    return;
  }
  const isAboveViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return rect.bottom <= 0;
  };
  const observer = new IntersectionObserver((entries, observerInstance) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }
      const element = entry.target;
      element.classList.add('animation-on');
      observerInstance.unobserve(element);
    });
  },
  {
    threshold: 0,
    rootMargin: '0px 0px -5% 0px',
  });
  animatedBlocks.forEach((block) => {
    if (isAboveViewport(block)) {
      block.classList.add('animation-on');
      return;
    }
    observer.observe(block);
  });
};
